import { createFailedUploadOutcome } from '../../../Services/candidateFileUpload';

export const createCandidatePhotoUploadOutcome = ({ clientOperationId, file, replacementStatus }) => {
  return createFailedUploadOutcome({
    clientOperationId,
    file,
    isProfilePhoto: true,
    replacementStatus,
  });
};
